import React from 'react';
import {Form, Divider, Grid} from 'semantic-ui-react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import RoleAndProgramsContainer from './orgUserRoleProgramContainer';
import _ from 'lodash';

const OrgUserManageForm = ({
  loading,
  manageModalVisible,
  openManageTeamModal,
  closeManageTeamModal,
  selectedOrgId,
  prioritizePhoneList,
  selectedUser,
  resetState,
  reloadUserList,
  isLoggedInAOR,
  stateUser,
  programs,
  assignedPrograms,
  subOrgToggle,
  renderType,
  displayNameParent,
  parentOrgs,
  parentOrgId,
  orgs,
  toggles,
}) => {
  return (
    <React.Fragment>
      <FemaGoModal
        title={
          renderType == 'subOrg' && subOrgToggle
            ? "Manage this user's access"
            : 'Manage this team member'
        }
        open={manageModalVisible}
        size="small"
        closeOnDimmerClick="no"
        confirmButton="hidden"
        cancelAction={() => {
          openManageTeamModal(selectedUser);
        }}
      >
        {!loading ? (
          <Form id="org-team-form">
            <p>
              Review and update contact information, roles and permissions assigned to
              this member of your {renderType == 'subOrg' && subOrgToggle && 'sub'}
              organization.
            </p>
            <div className="user-details">
              <Grid celled>
                <Grid.Row>
                  <Grid.Column width={5}>
                    <strong>
                      {selectedUser.firstName} {selectedUser.lastName}
                    </strong>
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <small>
                      {_.includes(toggles, 'loginGovIntegration') ? 
                      <strong>Email for notifications:</strong>
                      : 
                      <strong>Email:</strong>
                    }
                    </small>{' '}
                    <br />
                    <span className="wrapped-span">{selectedUser.emailAdr}</span>
                    {subOrgToggle && renderType == 'subOrg' && (
                      <span>
                        <br />
                        <small>
                          <strong>Phone:</strong>
                        </small>{' '}
                        <br />
                        {prioritizePhoneList(selectedUser)}
                      </span>
                    )}
                  </Grid.Column>
                  {renderType == 'org' && (
                    <Grid.Column width={4}>
                      <small>
                        <strong>Phone:</strong>
                      </small>{' '}
                      <br />
                      {prioritizePhoneList(selectedUser)}
                    </Grid.Column>
                  )}
                </Grid.Row>
              </Grid>
            </div>
            <RoleAndProgramsContainer
              selectedOrgId={selectedOrgId}
              selectedUser={selectedUser}
              openManageTeamModal={openManageTeamModal}
              closeManageTeamModal={closeManageTeamModal}
              resetState={resetState}
              reloadUserList={reloadUserList}
              isLoggedInAOR={isLoggedInAOR}
              stateUser={stateUser}
              programs={programs}
              assignedPrograms={assignedPrograms}
              subOrgToggle={subOrgToggle}
              renderType={renderType}
              displayNameParent={displayNameParent}
              parentOrgs={parentOrgs}
              parentOrgId={parentOrgId}
              orgs={orgs}
            />
          </Form>
        ) : (
          <div>Loading entities</div>
        )}
      </FemaGoModal>
    </React.Fragment>
  );
};

export default OrgUserManageForm;
